// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__FQ-9w","label":"Input_label__Ow7_w","div":"Input_div__jsHw5"};